import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Drawer, IconButton, Divider,
} from '@mui/material';
import {
  Clear as ClearIcon,
} from '@mui/icons-material';
import detailUrl from '../../../../constants/frontUrls';
import DataTable from '../../../../components/templates/dataTable/DataTable';

export default function CalendarDetailList(props) {
  const {
    searchCondition, onSearch, onClose, open,
  } = props;
  const dbDatas = useSelector((state) => state.opportunityListStore.datas);
  const [datas, setDatas] = useState({ totalElements: 0 });

  useEffect(() => {
    if (dbDatas) {
      setDatas(dbDatas);
    }
  }, [dbDatas]);

  const headCells = [
    { id: 'opportunityNumber', label: '案件番号', sortId: 'opportunity_number' },
    {
      id: 'totalPrice', label: '税込合計金額', sortId: 'total_price', numeric: true,
    },
    { id: 'heldDate', label: '開催日', sortId: 'held_date' },
    { id: 'serviceTypeName', label: '提供方法', sortId: 'service_type_name' },
    { id: 'joinNumber', label: '参加人数', sortId: 'join_number' },
    { id: 'address', label: '開催場所住所', sortId: 'address' },
    { id: 'customerName', label: 'お客様名', sortId: 'customer_name' },
  ];

  const onChangePage = (_, newPage) => {
    const tempCondition = {
      ...searchCondition,
      page: newPage,
    };
    onSearch(tempCondition);
  };

  const onChangeRowsPerPage = (event) => {
    const rowsPerPage = parseInt(event.target.value, 10);
    const tempCondition = {
      ...searchCondition,
      page: 0,
      records: rowsPerPage,
    };
    onSearch(tempCondition);
  };

  const handleRequestSort = (_, property) => {
    const { order, orderBy } = property;
    const tempCondition = {
      ...searchCondition,
      page: 0,
      order,
      orderBy,
    };
    onSearch(tempCondition);
  };

  return (
    <Drawer
      variant="persistent"
      anchor="right"
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', md: '50%' },
        },
        flexShrink: 0,
        whiteSpace: 'nowrap',
      }}
      open={open}
    >
      <div>
        <IconButton onClick={onClose}>
          <ClearIcon />
        </IconButton>
      </div>
      <Divider />
      <DataTable
        url={detailUrl.OPPORTUNITY_CALENDAR_DETAIL}
        rows={datas.content || []}
        headCells={headCells}
        page={searchCondition.page}
        rowsPerPage={searchCondition.records}
        totalElements={datas.totalElements || 0}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        handleRequestSort={handleRequestSort}
        order={searchCondition.order}
        orderBy={searchCondition.orderBy}
      />
    </Drawer>
  );
}
